import { Component, OnInit } from '@angular/core';
import { latest } from './latest'
@Component({
  selector: 'app-latestmovies',
  templateUrl: './latestmovies.component.html',
  styleUrls: ['./latestmovies.component.css']
})
export class LatestmoviesComponent implements OnInit {
  datas: object[]
  loading: boolean
  constructor() {
  }

  ngOnInit() {
    this.loading = true
    setTimeout(() => {
      this.datas = latest
      this.loading = false
    }, 700)
  }
}
